export enum Environment {
    DEV = "dev",
    STG1 = "stg1",
    STG2 = "stg2",
    PROD = "prod",
}

export enum MaskMessage {
    INTAKE_COMPLETED = "intakeCompleted",
    PARTIAL_REJECTION = "partialRejection",
    TERMINAL_REJECTION = "terminalRejection"
}

export enum PhaseAccessStatus {
    ALLOWED = "ALLOWED",
    EXPIRED = "EXPIRED",
    RESTRICTED_PHASE = "RESTRICTED_PHASE",
}
